import 'css-chunksrc/client/pages/zonePage/projectsPage/toolbar/sortDropdown/styles.scss';export default {
  "root": "_root_1g9u2_1",
  "listRoot": "_listRoot_1g9u2_5",
  "input": "_input_1g9u2_13",
  "opened": "_opened_1g9u2_32",
  "icon": "_icon_1g9u2_37",
  "list": "_list_1g9u2_5",
  "option": "_option_1g9u2_59",
  "selected": "_selected_1g9u2_66"
};